import {api} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {StorageUtil} from '../../../common/Auth';

export default {
  name: 'bookcontent',
  data() {
    return {
      book: {}
    }
  },
  beforeMount() {
    var isbn = this.$route.query.isbn;
    if(this.$route.query.libCode){
        var hallCode = this.$route.query.libCode
    }else{
        var hallCode = this.$route.query.hallCode
    }
    var url = api.book.info.replace('{isbn}', isbn).replace('{hallCode}',hallCode);
    ajaxUtil.ajaxJson(url, null, "get", (data)=> {
      this.book = data;
      StorageUtil.storeString("currHallCodeExist",this.book.currHallCodeExist);      
    }, null, this);
  },
}
